// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Ftiles.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { BlobRefType, OpenType } from '../../tiles';
import { Binary, Blob, ContextHolder, Document, DynamicContext, EventsHolder, GridCell, GridNeighborhoodContext, ItemFilter, Session, SubDocument, TenantContextHolder, TileGroup, UserCommandsHolder, UserContextHolder } from '../tiles.g';
import { schemaObjectHeaderValidatorInstance } from '../../generated/validator/schema-object-validator.g';
import { validateArray } from '@augloop/validator-common';
export class BlobRefValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'BlobRef: Expected object, got undefined object for BlobRefValidator' };
        }
        if (obj.refType === undefined) {
            return { success: false, error: 'BlobRef: Required field "refType" is missing' };
        }
        else {
            const result = blobRefTypeValidatorInstance.validate(obj.refType);
            if (!result.success) {
                result.error = "BlobRef.refType: " + result.error;
                return result;
            }
        }
        if (obj.value === undefined) {
            return { success: false, error: 'BlobRef: Required field "value" is missing' };
        }
        else if (typeof obj.value !== 'string') {
            return { success: false, error: 'BlobRef: Required field "value" is wrong type' };
        }
        return { success: true };
    }
}
export const blobRefValidatorInstance = new BlobRefValidator();
export class BlobTokenValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'BlobToken: Expected object, got undefined object for BlobTokenValidator' };
        }
        if (obj.codedLocation === undefined) {
            return { success: false, error: 'BlobToken: Required field "codedLocation" is missing' };
        }
        else if (typeof obj.codedLocation !== 'string') {
            return { success: false, error: 'BlobToken: Required field "codedLocation" is wrong type' };
        }
        if (obj.sizeBytes === undefined) {
            return { success: false, error: 'BlobToken: Required field "sizeBytes" is missing' };
        }
        else if (typeof obj.sizeBytes !== 'number') {
            return { success: false, error: 'BlobToken: Required field "sizeBytes" is wrong type' };
        }
        if (obj.id === undefined) {
            return { success: false, error: 'BlobToken: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'BlobToken: Required field "id" is wrong type' };
        }
        if (obj.gatewayUrl === undefined) {
            return { success: false, error: 'BlobToken: Required field "gatewayUrl" is missing' };
        }
        else if (typeof obj.gatewayUrl !== 'string') {
            return { success: false, error: 'BlobToken: Required field "gatewayUrl" is wrong type' };
        }
        return { success: true };
    }
}
export const blobTokenValidatorInstance = new BlobTokenValidator();
export class BlobValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Blob: Expected object, got undefined object for BlobValidator' };
        }
        if (obj.id === undefined) {
            return { success: false, error: 'Blob: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'Blob: Required field "id" is wrong type' };
        }
        if (obj.sizeBytes === undefined) {
            return { success: false, error: 'Blob: Required field "sizeBytes" is missing' };
        }
        else if (typeof obj.sizeBytes !== 'number') {
            return { success: false, error: 'Blob: Required field "sizeBytes" is wrong type' };
        }
        if ((obj.data !== undefined) && !(obj.data instanceof Uint8Array)) {
            return { success: false, error: 'Blob: Optional field "data" is wrong type' };
        }
        if ((obj.dataPointer !== undefined)) {
            const result = blobRefValidatorInstance.validate(obj.dataPointer);
            if (!result.success) {
                result.error = "Blob.dataPointer: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Blob.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Blob"' };
        }
        return { success: true };
    }
}
export const blobValidatorInstance = new BlobValidator();
export class BinaryValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Binary: Expected object, got undefined object for BinaryValidator' };
        }
        if ((obj.data !== undefined) && !(obj.data instanceof Uint8Array)) {
            return { success: false, error: 'Binary: Optional field "data" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Binary.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Binary"' };
        }
        return { success: true };
    }
}
export const binaryValidatorInstance = new BinaryValidator();
export class TileGroupValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'TileGroup: Expected object, got undefined object for TileGroupValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!TileGroup.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "TileGroup"' };
        }
        return { success: true };
    }
}
export const tileGroupValidatorInstance = new TileGroupValidator();
export class SessionValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Session: Expected object, got undefined object for SessionValidator' };
        }
        if (obj.activeUserId === undefined) {
            return { success: false, error: 'Session: Required field "activeUserId" is missing' };
        }
        else if (typeof obj.activeUserId !== 'string') {
            return { success: false, error: 'Session: Required field "activeUserId" is wrong type' };
        }
        if ((obj.widthDpi !== undefined) && (typeof obj.widthDpi !== 'number')) {
            return { success: false, error: 'Session: Optional field "widthDpi" is wrong type' };
        }
        if ((obj.heightDpi !== undefined) && (typeof obj.heightDpi !== 'number')) {
            return { success: false, error: 'Session: Optional field "heightDpi" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Session.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Session"' };
        }
        return { success: true };
    }
}
export const sessionValidatorInstance = new SessionValidator();
export class DocumentValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Document: Expected object, got undefined object for DocumentValidator' };
        }
        if (obj.isReadonly === undefined) {
            return { success: false, error: 'Document: Required field "isReadonly" is missing' };
        }
        else if (typeof obj.isReadonly !== 'boolean') {
            return { success: false, error: 'Document: Required field "isReadonly" is wrong type' };
        }
        if ((obj.title !== undefined) && (typeof obj.title !== 'string')) {
            return { success: false, error: 'Document: Optional field "title" is wrong type' };
        }
        if ((obj.url !== undefined) && (typeof obj.url !== 'string')) {
            return { success: false, error: 'Document: Optional field "url" is wrong type' };
        }
        if ((obj.openType !== undefined)) {
            const result = openTypeValidatorInstance.validate(obj.openType);
            if (!result.success) {
                result.error = "Document.openType: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Document.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Document"' };
        }
        return { success: true };
    }
}
export const documentValidatorInstance = new DocumentValidator();
export class SubDocumentValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SubDocument: Expected object, got undefined object for SubDocumentValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SubDocument.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SubDocument"' };
        }
        return { success: true };
    }
}
export const subDocumentValidatorInstance = new SubDocumentValidator();
export class GridCellValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GridCell: Expected object, got undefined object for GridCellValidator' };
        }
        if (obj.column === undefined) {
            return { success: false, error: 'GridCell: Required field "column" is missing' };
        }
        else if (typeof obj.column !== 'number') {
            return { success: false, error: 'GridCell: Required field "column" is wrong type' };
        }
        if (obj.row === undefined) {
            return { success: false, error: 'GridCell: Required field "row" is missing' };
        }
        else if (typeof obj.row !== 'number') {
            return { success: false, error: 'GridCell: Required field "row" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GridCell.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GridCell"' };
        }
        return { success: true };
    }
}
export const gridCellValidatorInstance = new GridCellValidator();
export class GridNeighborhoodContextValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GridNeighborhoodContext: Expected object, got undefined object for GridNeighborhoodContextValidator' };
        }
        if (obj.width === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "width" is missing' };
        }
        else if (typeof obj.width !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "width" is wrong type' };
        }
        if (obj.height === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "height" is missing' };
        }
        else if (typeof obj.height !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "height" is wrong type' };
        }
        if (obj.retrievedWidth === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "retrievedWidth" is missing' };
        }
        else if (typeof obj.retrievedWidth !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "retrievedWidth" is wrong type' };
        }
        if (obj.retrievedHeight === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "retrievedHeight" is missing' };
        }
        else if (typeof obj.retrievedHeight !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "retrievedHeight" is wrong type' };
        }
        if (obj.neighborhoodTopRow === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "neighborhoodTopRow" is missing' };
        }
        else if (typeof obj.neighborhoodTopRow !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "neighborhoodTopRow" is wrong type' };
        }
        if (obj.neighborhoodLeftColumn === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "neighborhoodLeftColumn" is missing' };
        }
        else if (typeof obj.neighborhoodLeftColumn !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "neighborhoodLeftColumn" is wrong type' };
        }
        if (obj.targetGridTopRow === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridTopRow" is missing' };
        }
        else if (typeof obj.targetGridTopRow !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridTopRow" is wrong type' };
        }
        if (obj.targetGridLeftColumn === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridLeftColumn" is missing' };
        }
        else if (typeof obj.targetGridLeftColumn !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridLeftColumn" is wrong type' };
        }
        if (obj.targetGridRelativeTopRow === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridRelativeTopRow" is missing' };
        }
        else if (typeof obj.targetGridRelativeTopRow !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridRelativeTopRow" is wrong type' };
        }
        if (obj.targetGridRelativeLeftColumn === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridRelativeLeftColumn" is missing' };
        }
        else if (typeof obj.targetGridRelativeLeftColumn !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "targetGridRelativeLeftColumn" is wrong type' };
        }
        if (obj.numberOfNonEmptyCells === undefined) {
            return { success: false, error: 'GridNeighborhoodContext: Required field "numberOfNonEmptyCells" is missing' };
        }
        else if (typeof obj.numberOfNonEmptyCells !== 'number') {
            return { success: false, error: 'GridNeighborhoodContext: Required field "numberOfNonEmptyCells" is wrong type' };
        }
        if ((obj.numberOfNonEmptyCellsInWorksheet !== undefined) && (typeof obj.numberOfNonEmptyCellsInWorksheet !== 'number')) {
            return { success: false, error: 'GridNeighborhoodContext: Optional field "numberOfNonEmptyCellsInWorksheet" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GridNeighborhoodContext.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GridNeighborhoodContext"' };
        }
        return { success: true };
    }
}
export const gridNeighborhoodContextValidatorInstance = new GridNeighborhoodContextValidator();
export class ItemFilterValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ItemFilter: Expected object, got undefined object for ItemFilterValidator' };
        }
        if ((obj.id !== undefined) && (typeof obj.id !== 'string')) {
            return { success: false, error: 'ItemFilter: Optional field "id" is wrong type' };
        }
        if (obj.ids !== undefined) {
            const result = validateArray(obj.ids, 1, undefined, 'string');
            if (!result.success) {
                result.error = "ItemFilter.ids: " + result.error;
                return result;
            }
        }
        if ((obj.itemType !== undefined) && (typeof obj.itemType !== 'string')) {
            return { success: false, error: 'ItemFilter: Optional field "itemType" is wrong type' };
        }
        if (obj.itemTypes !== undefined) {
            const result = validateArray(obj.itemTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "ItemFilter.itemTypes: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ItemFilter.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ItemFilter"' };
        }
        return { success: true };
    }
}
export const itemFilterValidatorInstance = new ItemFilterValidator();
export class DynamicContextValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'DynamicContext: Expected object, got undefined object for DynamicContextValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!DynamicContext.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "DynamicContext"' };
        }
        return { success: true };
    }
}
export const dynamicContextValidatorInstance = new DynamicContextValidator();
export class ContextHolderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ContextHolder: Expected object, got undefined object for ContextHolderValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ContextHolder.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ContextHolder"' };
        }
        return { success: true };
    }
}
export const contextHolderValidatorInstance = new ContextHolderValidator();
export class UserContextHolderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'UserContextHolder: Expected object, got undefined object for UserContextHolderValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!UserContextHolder.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "UserContextHolder"' };
        }
        return { success: true };
    }
}
export const userContextHolderValidatorInstance = new UserContextHolderValidator();
export class TenantContextHolderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'TenantContextHolder: Expected object, got undefined object for TenantContextHolderValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!TenantContextHolder.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "TenantContextHolder"' };
        }
        return { success: true };
    }
}
export const tenantContextHolderValidatorInstance = new TenantContextHolderValidator();
export class EventsHolderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'EventsHolder: Expected object, got undefined object for EventsHolderValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!EventsHolder.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "EventsHolder"' };
        }
        return { success: true };
    }
}
export const eventsHolderValidatorInstance = new EventsHolderValidator();
export class UserCommandsHolderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'UserCommandsHolder: Expected object, got undefined object for UserCommandsHolderValidator' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!UserCommandsHolder.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "UserCommandsHolder"' };
        }
        return { success: true };
    }
}
export const userCommandsHolderValidatorInstance = new UserCommandsHolderValidator();
export class BlobRefTypeValidator {
    validate(value) {
        if (!BlobRefTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "BlobRefType"' };
        }
        return { success: true };
    }
}
BlobRefTypeValidator.validValues = new Set([BlobRefType.None, BlobRefType.HttpsGetDownloadUrl, BlobRefType.AlCodedLocation, BlobRefType.Token]);
export const blobRefTypeValidatorInstance = new BlobRefTypeValidator();
export class OpenTypeValidator {
    validate(value) {
        if (!OpenTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "OpenType"' };
        }
        return { success: true };
    }
}
OpenTypeValidator.validValues = new Set([OpenType.NewDocument, OpenType.EditDocument, OpenType.ViewOnlyDocument]);
export const openTypeValidatorInstance = new OpenTypeValidator();
//# sourceMappingURL=tiles-validator.g.js.map